import {
    Box,
    Typography,
    Grid,
    Divider,
    Paper,
    Modal,
    IconButton
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const CalendarModal = ({ open, onClose, events }) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "90%",
                    maxWidth: 900,
                    bgcolor: "#fff",
                    borderRadius: 3,
                    boxShadow: 24,
                    p: 3,
                    maxHeight: "90vh",
                    overflowY: "auto"
                }}
            >
                <Box textAlign="right">
                    <IconButton onClick={onClose}>
                        <HighlightOffIcon />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        background: "#671E78",
                        color: "#fff",
                        py: 2,
                        textAlign: "center",
                        borderRadius: "10px",
                        mb: 3
                    }}
                >
                    <Typography variant="h6" sx={{ fontFamily: "Gilroy-Bold" }}>
                        SCHOOL CALENDAR 2022–2023
                    </Typography>
                </Box>
                <Grid container spacing={2}>
                    {events.map((event, idx) => (
                        <Grid item xs={12} sm={6} key={idx}>
                            <Paper
                                variant="outlined"
                                sx={{
                                    borderRadius: 2,
                                    borderColor: "rgba(103,30,120,0.3)",
                                    p: 2,
                                    height: "100%",
                                    background: "#E7E5EB"
                                }}
                            >
                                <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: "bold", color: "#671E78", mb: 1 }}
                                >
                                    {event.date}
                                </Typography>
                                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 0.5 }}>
                                    {event.title}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {event.desc}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Modal>
    );
};

export default CalendarModal;
